import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import AsyncStorage from '@react-native-async-storage/async-storage';

interface MuteState {
  mutedUsers: Set<string>; // DIDs
  mutedWords: Set<string>; // 単語リスト
  
  // ユーザーミュート
  muteUser: (did: string) => void;
  unmuteUser: (did: string) => void;
  isUserMuted: (did: string) => boolean;
  
  // 単語ミュート
  muteWord: (word: string) => void;
  unmuteWord: (word: string) => void;
  isWordMuted: (word: string) => boolean;
  
  // テキストが単語ミュートに該当するかチェック
  containsMutedWord: (text: string) => boolean;
}

export const useMuteStore = create<MuteState>()(
  persist(
    (set, get) => ({
      mutedUsers: new Set(),
      mutedWords: new Set(),
      
      muteUser: (did: string) => {
        set((state) => ({
          mutedUsers: new Set([...state.mutedUsers, did]),
        }));
      },
      
      unmuteUser: (did: string) => {
        set((state) => {
          const newMutedUsers = new Set(state.mutedUsers);
          newMutedUsers.delete(did);
          return { mutedUsers: newMutedUsers };
        });
      },
      
      isUserMuted: (did: string) => {
        return get().mutedUsers.has(did);
      },
      
      muteWord: (word: string) => {
        set((state) => ({
          mutedWords: new Set([...state.mutedWords, word.toLowerCase()]),
        }));
      },
      
      unmuteWord: (word: string) => {
        set((state) => {
          const newMutedWords = new Set(state.mutedWords);
          newMutedWords.delete(word.toLowerCase());
          return { mutedWords: newMutedWords };
        });
      },
      
      isWordMuted: (word: string) => {
        return get().mutedWords.has(word.toLowerCase());
      },
      
      containsMutedWord: (text: string) => {
        const lowerText = text.toLowerCase();
        const mutedWords = get().mutedWords;
        
        for (const word of mutedWords) {
          if (lowerText.includes(word)) {
            return true;
          }
        }
        return false;
      },
    }),
    {
      name: 'mute-storage',
      storage: createJSONStorage(() => AsyncStorage),
      partialize: (state) => ({
        mutedUsers: Array.from(state.mutedUsers),
        mutedWords: Array.from(state.mutedWords),
      }),
      merge: (persistedState: any, currentState) => ({
        ...currentState,
        mutedUsers: new Set(persistedState?.mutedUsers || []),
        mutedWords: new Set(persistedState?.mutedWords || []),
      }),
    }
  )
);
